export default "__VITE_ASSET__6c68df08__"